
import { z } from "zod";

export const PricingTypeValues = ["CUSTOM", "DISCOUNT", "FEE", "LABOR", "MATERIALS", "REBATE"] as const;
export const PricingTypeSchema = z.enum(PricingTypeValues);
export const PricingType = PricingTypeSchema.enum;
export type PricingType = (typeof PricingTypeValues)[number];
export const PricingTypeDisplayNames = { "CUSTOM": "Custom",
"DISCOUNT": "Discount",
"FEE": "Fee",
"LABOR": "Labor",
"MATERIALS": "Materials",
"REBATE": "Rebate", } satisfies Record<PricingType, string>;
